import { BadgeCheck, CircleAlert, FilePenLine, Loader2 } from 'lucide-react';

import { TreatmentCheckInStatus } from '@/services/types/treatment-types';

function getIcon(status: TreatmentCheckInStatus) {
  switch (status) {
    case TreatmentCheckInStatus.NEEDS_REVIEW:
      return CircleAlert;
    case TreatmentCheckInStatus.COMPLETED:
      return BadgeCheck;
    case TreatmentCheckInStatus.PROCESSING:
      return Loader2;
    case TreatmentCheckInStatus.DRAFT:
    default:
      return FilePenLine;
  }
}

function getColorClass(status: TreatmentCheckInStatus) {
  switch (status) {
    case TreatmentCheckInStatus.NEEDS_REVIEW:
      return 'text-amber-500';
    case TreatmentCheckInStatus.COMPLETED:
      return 'text-emerald-500';
    case TreatmentCheckInStatus.PROCESSING:
      return 'text-blue-500';
    case TreatmentCheckInStatus.DRAFT:
    default:
      return 'text-gray-400';
  }
}

interface CheckInStatusIconProps {
  status: TreatmentCheckInStatus;
  className?: string;
}

export const CheckInStatusIcon = ({
  status,
  className,
}: CheckInStatusIconProps) => {
  const Icon = getIcon(status);
  const spin = status === TreatmentCheckInStatus.PROCESSING;
  const color = getColorClass(status);
  return (
    <Icon
      className={`h-5 w-5 ${spin ? 'animate-spin' : ''} ${color} ${className ?? ''}`}
    />
  );
};
